// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChartPrepSections-module__scroll___Qd1WC {
  margin: 0 -8px;
  overflow-x: auto;
}

.ChartPrepSections-module__sheet___WumzH {
  border-collapse: collapse;
  font-size: 14px;
  color: #18181b;
}

.ChartPrepSections-module__testCell___BZWDi {
  position: sticky;
  left: 0;
  z-index: 1;
  padding: 4px 12px 4px 8px;
  background: #ffffff;
  text-align: left;
  vertical-align: top;
}

.ChartPrepSections-module__corner___Zvmmy {
  padding-bottom: 6px;
  border-bottom: 1px solid #e4e4e7;
  vertical-align: bottom;
}

.ChartPrepSections-module__draw___YPE6y {
  padding: 0 12px 6px;
  border-bottom: 1px solid #e4e4e7;
  text-align: right;
  vertical-align: bottom;
  font-weight: 400;
  white-space: nowrap;
}

.ChartPrepSections-module__drawDate___g8te8 {
  display: block;
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  color: #71717a;
}

.ChartPrepSections-module__row___NjgWJ:hover, .ChartPrepSections-module__row___NjgWJ:hover .ChartPrepSections-module__testCell___BZWDi {
  background: #fafafa;
}
.ChartPrepSections-module__row___NjgWJ .ChartPrepSections-module__testCell___BZWDi {
  border-radius: 6px 0 0 6px;
}
.ChartPrepSections-module__row___NjgWJ .ChartPrepSections-module__value___DvdxL:last-child {
  border-radius: 0 6px 6px 0;
}

.ChartPrepSections-module__group___nb1MW {
  position: sticky;
  left: 0;
  padding: 10px 8px 2px;
  background: #ffffff;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #71717a;
}

.ChartPrepSections-module__testName___LOEl4 {
  font-weight: 500;
}

.ChartPrepSections-module__testLabel___JP6K7 {
  display: block;
  min-width: 144px;
}

.ChartPrepSections-module__caption___lsZCT {
  display: block;
  font-weight: 400;
}

.ChartPrepSections-module__quiet___v_z0X {
  font-size: 13px;
  color: #71717a;
}

.ChartPrepSections-module__value___DvdxL {
  padding: 4px 12px;
  text-align: right;
  vertical-align: top;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.ChartPrepSections-module__flagged___qEsQl {
  font-weight: 600;
  color: #b91c1c;
}

.ChartPrepSections-module__link___QLHgV {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  font-size: 13px;
  font-weight: 500;
  color: #18181b;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}
.ChartPrepSections-module__link___QLHgV svg {
  color: #a1a1aa;
}
.ChartPrepSections-module__link___QLHgV:hover {
  border-color: #18181b;
  color: #18181b;
}

.ChartPrepSections-module__more___DpZTk {
  padding: 10px 16px;
  border: none;
  background: none;
  text-align: left;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
  cursor: pointer;
}
.ChartPrepSections-module__more___DpZTk:hover {
  color: #18181b;
  text-decoration: underline;
}

.ChartPrepSections-module__lines___SKj04 {
  display: flex;
  flex-direction: column;
  margin: 0 -8px;
  padding: 10px 16px;
  list-style: none;
}

.ChartPrepSections-module__line___xTzXF {
  display: grid;
  grid-template-columns: 168px 64px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 14px;
  color: #18181b;
}
.ChartPrepSections-module__line___xTzXF:hover {
  background: #fafafa;
}

.ChartPrepSections-module__lineLabel___DUE2Y {
  font-weight: 500;
}

.ChartPrepSections-module__lineNote___rXFLM {
  display: block;
  font-weight: 400;
  color: #71717a;
}

.ChartPrepSections-module__lineDate___V6UBN {
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  color: #71717a;
}

.ChartPrepSections-module__lineResult___O7YMO {
  min-width: 0;
}

.ChartPrepSections-module__lineLink___Za8Fy {
  justify-self: end;
}

.ChartPrepSections-module__orderedHead___XurMA {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 500;
  color: #18181b;
}

.ChartPrepSections-module__orderedCount___K4I_9 {
  font-weight: 400;
  color: #71717a;
}

.ChartPrepSections-module__pending___xJmw1 {
  font-weight: 500;
  color: #b45309;
}

.ChartPrepSections-module__note___dvF8V {
  margin: 8px 0 0;
  font-size: 13px;
  color: #71717a;
}

.ChartPrepSections-module__srOnly___gYQux {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

@container (max-width: 639px) {
  .ChartPrepSections-module__line___xTzXF {
    grid-template-columns: minmax(0, 1fr);
    gap: 2px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f4f4f5;
  }
  .ChartPrepSections-module__lineLink___Za8Fy {
    justify-self: start;
  }
  .ChartPrepSections-module__testLabel___JP6K7 {
    min-width: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/ChartPrepSections.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,OAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;AACF;;AAGE;EAEE,mBAAA;AADJ;AAIE;EACE,0BAAA;AAFJ;AAKE;EACE,0BAAA;AAHJ;;AAOA;EACE,gBAAA;EACA,OAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;AAJF;;AAOA;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kCAAA;AAJF;;AAOA;EACE,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;AAJF;AAME;EACE,cAAA;AAJJ;AAOE;EACE,qBAAA;EACA,cAAA;AALJ;;AASA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AANF;AAQE;EACE,cAAA;EACA,0BAAA;AANJ;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,aAAA;EACA,qDAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAPF;AASE;EACE,mBAAA;AAPJ;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,gBAAA;EACA,cAAA;AARF;;AAWA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AARF;;AAWA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AARF;;AAWA;EACE;IACE,qCAAA;IACA,QAAA;IACA,mBAAA;IACA,gCAAA;EARF;EAWA;IACE,mBAAA;EATF;EAYA;IACE,gBAAA;EAVF;AACF","sourcesContent":[".scroll {\n  margin: 0 -8px;\n  overflow-x: auto;\n}\n\n.sheet {\n  border-collapse: collapse;\n  font-size: 14px;\n  color: #18181b;\n}\n\n.testCell {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n  padding: 4px 12px 4px 8px;\n  background: #ffffff;\n  text-align: left;\n  vertical-align: top;\n}\n\n.corner {\n  padding-bottom: 6px;\n  border-bottom: 1px solid #e4e4e7;\n  vertical-align: bottom;\n}\n\n.draw {\n  padding: 0 12px 6px;\n  border-bottom: 1px solid #e4e4e7;\n  text-align: right;\n  vertical-align: bottom;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.drawDate {\n  display: block;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.row {\n  &:hover,\n  &:hover .testCell {\n    background: #fafafa;\n  }\n\n  .testCell {\n    border-radius: 6px 0 0 6px;\n  }\n\n  .value:last-child {\n    border-radius: 0 6px 6px 0;\n  }\n}\n\n.group {\n  position: sticky;\n  left: 0;\n  padding: 10px 8px 2px;\n  background: #ffffff;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #71717a;\n}\n\n.testName {\n  font-weight: 500;\n}\n\n.testLabel {\n  display: block;\n  min-width: 144px;\n}\n\n.caption {\n  display: block;\n  font-weight: 400;\n}\n\n.quiet {\n  font-size: 13px;\n  color: #71717a;\n}\n\n.value {\n  padding: 4px 12px;\n  text-align: right;\n  vertical-align: top;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.flagged {\n  font-weight: 600;\n  color: #b91c1c;\n}\n\n.link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 8px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #18181b;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n\n  svg {\n    color: #a1a1aa;\n  }\n\n  &:hover {\n    border-color: #18181b;\n    color: #18181b;\n  }\n}\n\n.more {\n  padding: 10px 16px;\n  border: none;\n  background: none;\n  text-align: left;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #3f3f46;\n  cursor: pointer;\n\n  &:hover {\n    color: #18181b;\n    text-decoration: underline;\n  }\n}\n\n.lines {\n  display: flex;\n  flex-direction: column;\n  margin: 0 -8px;\n  padding: 10px 16px;\n  list-style: none;\n}\n\n.line {\n  display: grid;\n  grid-template-columns: 168px 64px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #18181b;\n\n  &:hover {\n    background: #fafafa;\n  }\n}\n\n.lineLabel {\n  font-weight: 500;\n}\n\n.lineNote {\n  display: block;\n  font-weight: 400;\n  color: #71717a;\n}\n\n.lineDate {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.lineResult {\n  min-width: 0;\n}\n\n.lineLink {\n  justify-self: end;\n}\n\n.orderedHead {\n  margin: 0 0 6px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.orderedCount {\n  font-weight: 400;\n  color: #71717a;\n}\n\n.pending {\n  font-weight: 500;\n  color: #b45309;\n}\n\n.note {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n}\n\n@container (max-width: 639px) {\n  .line {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 2px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #f4f4f5;\n  }\n\n  .lineLink {\n    justify-self: start;\n  }\n\n  .testLabel {\n    min-width: 120px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `ChartPrepSections-module__scroll___Qd1WC`,
	"sheet": `ChartPrepSections-module__sheet___WumzH`,
	"testCell": `ChartPrepSections-module__testCell___BZWDi`,
	"corner": `ChartPrepSections-module__corner___Zvmmy`,
	"draw": `ChartPrepSections-module__draw___YPE6y`,
	"drawDate": `ChartPrepSections-module__drawDate___g8te8`,
	"row": `ChartPrepSections-module__row___NjgWJ`,
	"value": `ChartPrepSections-module__value___DvdxL`,
	"group": `ChartPrepSections-module__group___nb1MW`,
	"testName": `ChartPrepSections-module__testName___LOEl4`,
	"testLabel": `ChartPrepSections-module__testLabel___JP6K7`,
	"caption": `ChartPrepSections-module__caption___lsZCT`,
	"quiet": `ChartPrepSections-module__quiet___v_z0X`,
	"flagged": `ChartPrepSections-module__flagged___qEsQl`,
	"link": `ChartPrepSections-module__link___QLHgV`,
	"more": `ChartPrepSections-module__more___DpZTk`,
	"lines": `ChartPrepSections-module__lines___SKj04`,
	"line": `ChartPrepSections-module__line___xTzXF`,
	"lineLabel": `ChartPrepSections-module__lineLabel___DUE2Y`,
	"lineNote": `ChartPrepSections-module__lineNote___rXFLM`,
	"lineDate": `ChartPrepSections-module__lineDate___V6UBN`,
	"lineResult": `ChartPrepSections-module__lineResult___O7YMO`,
	"lineLink": `ChartPrepSections-module__lineLink___Za8Fy`,
	"orderedHead": `ChartPrepSections-module__orderedHead___XurMA`,
	"orderedCount": `ChartPrepSections-module__orderedCount___K4I_9`,
	"pending": `ChartPrepSections-module__pending___xJmw1`,
	"note": `ChartPrepSections-module__note___dvF8V`,
	"srOnly": `ChartPrepSections-module__srOnly___gYQux`
};
module.exports = ___CSS_LOADER_EXPORT___;
